require('../../modules/es.number.parse-float');
var path = require('../../internals/path');

module.exports = path.Number.parseFloat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/number/parse-float.js
// module id = 3660
// module chunks = 25